import { Component, OnInit, Input } from '@angular/core';
import {TranslateService} from '@ngx-translate/core'
import { Platform, LoadingController, NavController, NavParams, ModalController } from '@ionic/angular';
import {GeneralServices} from '../../services/generalServices';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BusquedaGlobalService } from './busqueda-global.services';

@Component({
  selector: 'app-busqueda-global',
  templateUrl: './busqueda-global.page.html',
  styleUrls: ['./busqueda-global.page.scss'],
  providers:[TranslateService, GeneralServices, BusquedaGlobalService]
})
export class BusquedaGlobalPage implements OnInit {
  @Input()  _parent;
  public ruta;
  public title;
  public params;
  public camposMostrar;
  public fnCallback;
  public filtrarBD = false;
  public campofiltro;

  public _objectArray;
  public _objectArrayTemp;

  public searchBarText;

  constructor(private platform: Platform, 
    private translate: TranslateService, 
    private _generalServices:GeneralServices,
    private loadingCtrl: LoadingController,
    private _busquedaGlobalService: BusquedaGlobalService,
    private route: ActivatedRoute,
    private router:Router,
    public navCtrl: NavController, public navParams: NavParams,
    public modalController: ModalController) {
      
      this._parent = navParams.get('_parent');
      this.ruta = navParams.get('ruta');
      this.title = navParams.get('title');
      this.params = navParams.get('params');
      this.camposMostrar = navParams.get('camposMostrar');
      this.fnCallback = navParams.get('fnCallback');
      this.filtrarBD = navParams.get('filtrarBD');
      this.campofiltro = navParams.get('campofiltro');
      
    this._generalServices.setLanguage(this.translate);
   }

  ngOnInit() {
    this.getData();
  }

  getData(){
    this._busquedaGlobalService.getData(this.params,this.ruta).subscribe(
	    result => {
        this._objectArray = [];
        try{
          if($.trim(result["Data"]) != ''){
            result = result["Data"];
          }
        }catch(e){}
	      if(result!=''){
	          this._objectArray=result;
	          this._objectArrayTemp=result;
	      }
	    },
	    error =>{
	      
	    }
	    );
  }

  seleccionarItem(item){
    if($.trim(this.fnCallback)!=''){
      this._parent[this.fnCallback](item);
    }    
    this.modalController.dismiss();
    //this.navCtrl.pop();
  }

  closeModal(){
    this.modalController.dismiss();
  }

  initializeItems() {
      this._objectArray = this._objectArrayTemp;
  }

  getItems(ev: any) {
    
    this.searchBarText = ev.target.value;
    
      if(!this.filtrarBD){
        this.initializeItems();
        const val = ev.target.value;
        if (val && val.trim() != '') {
          this._objectArray = this._objectArray.filter((item) => {
            
            for(var i in this.camposMostrar){
              if(item[this.camposMostrar[i].name].toLowerCase().indexOf(val.toLowerCase()) > -1){
                return true;
              }
            }
          })
        }
      }
  }

  filtrar(){
    this.params[this.campofiltro]=this.searchBarText;
    this.getData();
  }


}
